define(function (require) {

    window.lpTag = window.lpTag || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var AcWrapper = require('web-agent-utils/AcWrapper');
    var widgetConfig = require('web-agent-widgets/widgetConfig');

    var agentWidgetsDataParams = {select:"$all"};
    var agentWidgetsModelPath = "agent.widgets";
    var POLLING_TIME = 300000;
    /**
     * Constructor, created an instance of the controller and initiating it's internal components and their initialization.
     * @param model
     */
    lpTag.lpAgentWidgetsController = function (model) {
        this.agentWidgetsModel = model;
        initializeACWrapper(this);
        registerToChannelChanges(this);
    };

/////////////////////////////////// PUBLIC METHODS ///////////////////////////////////////

    lpTag.lpAgentWidgetsController.prototype.applicationType = "lpAgentWidgetsController";

    /**
     * a utility function that will be used for QA purposes, with it we can create demo widgets from the console by passing a widgets config json to the method.
     * if no widget config is passed the function will create an hard coded demo widget.
     * @param widgetConfig
     */
    lpTag.lpAgentWidgetsController.prototype.addAgentWidget = function(widgetConfig){
        widgetConfig = widgetConfig || {};
        var customWidget = {
            span: widgetConfig.span || 1,
            id:  widgetConfig.id || -1,
            url: widgetConfig.url || '',
            name: widgetConfig.name || 'demo widget',
            order: widgetConfig.order || 1,
            enabled: true,
            mode: widgetConfig.mode || '',
            parameters: widgetConfig.parameters
        };
        if (this.agentWidgetsModel) {
            this.agentWidgetsModel.modify(agentWidgetsModelPath, [customWidget], "id");
        }
    };

    /**
     * Makes the request the AC service to get the latest configuration.
     */
    lpTag.lpAgentWidgetsController.prototype.getAgentWidgetsData = function(reqData) {
        getAgentWidgetsData(this, reqData);
    };

    var logger = WebAgentLogger.getLogger(lpTag.lpAgentWidgetsController.prototype.applicationType);
    var errorCounter = 0;

/////////////////////////////////// PRIVATE METHODS //////////////////////////////////////

    /**
     * Creates the instance of the AC wrapper needed to communicate with Personalization AC
     */
    function initializeACWrapper(context) {
        var acKeys = agentLEManager.getLEUrlResolverApiResourcesService("AccountConfig");
        if (acKeys && acKeys.Personalization && acKeys.Personalization.EnabledAgentWidgets) {
            context.agentWidgetsACWrapper = AcWrapper.createInstance(acKeys.Personalization.AgentWidgets, "AgentWidgets");
        }
    }

    /**
     * This method registers on the webAgent channel the following changes:
     * - Command that reloads the data from the API.
     *   (The purpose for this method is mainly to enable the Widget-Configuration module to notify us that the configuration was changed)
     * - Method for getting the visitInfo parameters in a flat structure.
     *   (This is used by the configuration component to determine which parameters it can configure to pass by the url.)
     */
    function registerToChannelChanges(context) {
        var webAgentChannel = agentLEManager.channelLE();
        var webAgentMediaCodes = agentLEManager.getLEMediaCodesWebAgent();
        if (webAgentChannel && webAgentMediaCodes) {
            webAgentChannel.reply(webAgentMediaCodes.reqres.getFlatWidgetConfig, getFlatVisitInfoParameters);
            webAgentChannel.reply(webAgentMediaCodes.reqres.addCustomVariables, shouldAddCustomVariables);
            webAgentChannel.reply(webAgentMediaCodes.reqres.getAgentName, getAgentNameFromModel);
        }

        function getFlatVisitInfoParameters () {
            return widgetConfig.getInstance().getFlatWidgetConfig("visitInfo");
        }

        function shouldAddCustomVariables () {
            return !agentLEManager.hasLiveEngage2Feature();
        }

        function getAgentNameFromModel () {
            return lpTag.WebAgent.logicController.getModelParam('agent.agentName');
        }
    }

    /**
     * Makes the request the AC service to get the latest configuration.
     */
    function getAgentWidgetsData(context, reqData) {
        if (context.agentWidgetsACWrapper) {
            context.agentWidgetsACWrapper.getValue({
                success : function(data) {
                    handleSuccess.call(context, data);
                    runSuccessCallback(reqData, data);
                },
                error : function(data) {
                    handleError.call(context, data);
                    runErrorCallback(reqData, data);
                },
                context : context,
                data : agentWidgetsDataParams
            });
        }
    }

    /**
     * Handle success responses from the service.
     * Writes the returned configuration to the model.
     * @param data
     */
    function handleSuccess(data) {
        if (data && data.body) {
            // save configuration to the model
            if (this.agentWidgetsModel) {
                this.agentWidgetsModel.set(agentWidgetsModelPath, data.body);
            }
        } else {
            this.agentWidgetsModel.set(agentWidgetsModelPath, []);
        }
        errorCounter = 0;
        this.agentWidgetsACWrapper.stopPolling();
    }

    /**
     * Handle error responses from the service and writes the error data to the model.
     * @param data
     */
    function handleError(data) {
        var reqData = {
            success : handleSuccess.bind(this, data),
            error : handleError.bind(this, data),
            context : this,
            data : agentWidgetsDataParams
        };

        if(errorCounter < 2){
            ++errorCounter;
            this.agentWidgetsACWrapper.getValue(reqData);
        } else if(errorCounter === 2) {
            ++errorCounter;
            reqData.pollingTimeout = POLLING_TIME;
            reqData.keepPollingOnError = true;
            this.agentWidgetsACWrapper.startGetPollingRequest(reqData);
        }

        if (data && data.body) {
            // save error details to the model
            if (this.agentWidgetsModel) {
                this.agentWidgetsModel.set(agentWidgetsModelPath, { error : data.body });
            }
        } else {
            this.agentWidgetsModel.set(agentWidgetsModelPath, []);
        }
    }

    /**
     * Method for running direct error callbacks supplied to functions
     * @param requestObj
     * @param data
     */
    function runErrorCallback (requestObj, data) {
        if (requestObj && requestObj.error) {
            runCallback(requestObj.error, requestObj, data);
        }
        data = null;
        requestObj = null;
    }

    /**
     * Method for running direct success callbacks supplied to functions
     * @param requestObj
     * @param data
     */
    function runSuccessCallback (requestObj, data) {
        if (requestObj && requestObj.success) {
            runCallback(requestObj.success, requestObj, data);
        }
        data = null;
        requestObj = null;
    }

    /**
     * Generic method for running callbacks
     * @param callback
     * @param requestObj
     * @param data
     */
    function runCallback (callback, requestObj, data) {
        if (callback && typeof callback === 'function') {
            try {
                callback.apply(requestObj.context || requestObj, [data]);
            } catch (err) {
                logger.error("Failed to run callback ", requestObj.callingFunction, err);
            }
        }
        callback = null;
        data = null;
        requestObj = null;
    }

    return lpTag.lpAgentWidgetsController;

});
